import { IActor } from '../../types/organization';

export interface IToken {
  accessToken: string;
  refreshToken?: string;
}

export type AuthState = 'loading' | 'success' | 'error';

export interface IJwtRole {
  id: string;
  name: string;
}

export interface IJwtOrg {
  id: string;
  name: string;
  type: OrgType;
  roles: IJwtRole[];
}

export interface IJwtPayload {
  sub: string;
  email: string;
  organizations: IJwtOrg[];
  business_groups: string[];
  iss: string;
  aud: string;
  iat: number;
  exp: number;
  nbf?: number;
  jti?: string;
}

export enum OrgType {
  SUPER = 'SUPER',
  REGULAR = 'REGULAR',
}

export enum ScopeLevel {
  ADMIN = 'ADMIN',
  STANDARD = 'STANDARD',
}

export enum ScopeCategory {
  ROLE = 'ROLE',
  USER = 'USER',
  ORG = 'ORG',
  SCOPE = 'SCOPE',
  BUSINESS_GROUP = 'BUSINESS_GROUP',
}

export interface IScope {
  name: string;
  level: ScopeLevel;
  category: ScopeCategory;
  description: string;
  serviceName: string;
  createdAt: string;
  updatedAt: string;
}

export interface IRole {
  id: string;
  orgId: string;
  name: string;
  scopeIds: string[];
  scopeGroupIds: string[];
  system?: boolean;
  createdBy?: IActor;
  updatedBy?: IActor;
  createdAt: string;
  updatedAt: string;
}

export interface IUserProfile {
  id: string;
  email: string;
  userOrgRoles: IRole[];
  userOrgScopes: IScope[];
}

export interface IPerson {
  id: string;
  [key: string]: any;
}

export interface IOAuth2Config {
  clientId: string;
  authUrl: string;
  tokenUrl: string;
  redirectUri: string;
  scope: string;
  responseType: string;
  codeChallengeMethod: string;
  grantType: string;
}

export enum AppType {
  ADMIN = 'ADMIN',
  CLIENT = 'CLIENT',
}
